import { render, staticRenderFns } from "./DetalleHistorial.vue?vue&type=template&id=e7953c4c"
import script from "./DetalleHistorial.vue?vue&type=script&lang=js"
export * from "./DetalleHistorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports